(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["funto-cart-total"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('funto-cart-total'))customElements.define('funto-cart-total',class extends HTMLElement{
  connectedCallback(){
    this.root=document.getElementById('MainProduct-'+this.dataset.section);
    if(!this.root)return;
    try{this.variants=JSON.parse(this.querySelector('script').textContent)}catch{return}
    this.labelTemplate=this.root.querySelector('#ProductSubmitButton-'+this.dataset.section+' .main-atc__label__text')?.cloneNode(true);
    this.stickyClick=event=>{
      const stickyButton=event.target.closest('sticky-atc .sticky-atc__add_button');
      if(!stickyButton||!this.root.contains(stickyButton))return;
      event.preventDefault();event.stopImmediatePropagation();
      const main=document.getElementById('ProductSubmitButton-'+this.dataset.section);
      if(!main||main.matches(':disabled')||main.dataset.unavailable==='true'||main.classList.contains('loading')||main.getAttribute('aria-disabled')==='true')return;
      this.update();
      main.click();
    };
    this.root.addEventListener('click',this.stickyClick,true);
    this.schedule=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};
    this.root.addEventListener('input',this.schedule);this.root.addEventListener('change',this.schedule);this.root.addEventListener('click',this.schedule);
    this.observer=new MutationObserver(this.schedule);this.observer.observe(this.root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-selected','data-id','data-price','value','disabled','data-unavailable']});
    this.update();
  }
  update(){
    const form=document.getElementById('product-form-'+this.dataset.section);
    const id=form?.querySelector('input[name="id"]')?.value;
    const variant=this.variants.find(item=>String(item.id)===String(id));
    const quantityInput=document.getElementById('Quantity-'+this.dataset.section);
    const paperBreaks=this.root.querySelector('quantity-breaks[data-funto-paper-quantities]');
    const checkedQuantity=paperBreaks?.querySelector('input[type="radio"][name="quantity"]:checked');
    const quantity=Math.max(Number(quantityInput?.min)||1,parseInt(checkedQuantity?.value||quantityInput?.value,10)||1);
    if(!variant)return;
    let total=Number(variant.price)*quantity;
    if(checkedQuantity){
      const offer=paperBreaks.querySelector('label[for="'+checkedQuantity.id+'"]');
      const selected=[...offer?.querySelectorAll('[data-selected-id]')||[]];
      if(selected.length===quantity)total=selected.reduce((sum,item)=>sum+Number(this.variants.find(v=>String(v.id)===String(item.dataset.selectedId))?.price||variant.price),0);
    }
    this.root.querySelectorAll('[data-funto-paper-quantity] .funto-paper-extra-row').forEach(row=>{
      const extra=this.variants.find(v=>String(v.id)===row.querySelector('[data-funto-extra-variant]')?.value);
      if(extra)total+=Number(extra.price)*Math.max(1,Math.floor(Number(row.querySelector('[data-funto-extra-count]')?.value)||1));
    });
    this.root.querySelectorAll('.funto-kit-card[data-selected="true"]').forEach(card=>{if(!card.querySelector('button')?.disabled)total+=Number(card.dataset.price)||0});
    const button=document.getElementById('ProductSubmitButton-'+this.dataset.section);
    if(!button||button.disabled||button.dataset.unavailable==='true')return;
    let price=button.querySelector('.main-atc-price > span');
    if(!price&&this.labelTemplate){
      const label=button.querySelector('.main-atc__label__text');
      if(label)label.replaceWith(this.labelTemplate.cloneNode(true));
      price=button.querySelector('.main-atc-price > span');
    }
    if(!price)return;
    const formatted=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(total/100);
    if(price.textContent!==formatted)price.textContent=formatted;
    if(price.getAttribute('aria-live')!=='polite')price.setAttribute('aria-live','polite');
    const sticky=document.getElementById('sticky-atc-'+this.dataset.section);
    const separate=sticky?.querySelector('[id^="sticky-atc-separate-price-"]');
    if(separate){
      let amount=separate.querySelector('[data-funto-sticky-total]');
      if(!amount){
        amount=document.createElement('span');
        amount.dataset.funtoStickyTotal='';
        amount.setAttribute('aria-live','polite');
        separate.replaceChildren(amount);
      }
      if(amount.textContent!==formatted)amount.textContent=formatted;
    }
    const buttonPrice=sticky?.querySelector('[id^="sticky-atc-price-"]');
    if(buttonPrice){
      const text=formatted+' • ';
      if(buttonPrice.textContent!==text)buttonPrice.textContent=text;
    }
    if(button.dataset.funtoTotal!==String(total))button.dataset.funtoTotal=String(total);
  }
  disconnectedCallback(){
    this.root?.removeEventListener('click',this.stickyClick,true);
    this.observer?.disconnect();cancelAnimationFrame(this.frame);
    this.root?.removeEventListener('input',this.schedule);this.root?.removeEventListener('change',this.schedule);this.root?.removeEventListener('click',this.schedule);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["funto-kit-addons"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('funto-kit-addons'))customElements.define('funto-kit-addons',class extends HTMLElement{
  connectedCallback(){
    this.sync=()=>this.querySelectorAll('product-info-upsell').forEach(card=>{const button=card.querySelector('button');if(button)button.setAttribute('aria-pressed',card.dataset.selected==='true'?'true':'false')});
    this.onVariantChange=event=>{
      const select=event.target.closest('[data-funto-addon-variant]');
      if(!select)return;
      const card=select.closest('product-info-upsell'),option=select.selectedOptions[0];
      if(!card||!option||option.disabled)return;
      card.dataset.id=option.value;
      card.dataset.price=option.dataset.price;
      card.querySelector('.funto-kit-card__price').textContent=option.dataset.money;
      const image=card.querySelector('.funto-kit-card__image img');
      if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image}
    };
    this.addEventListener('change',this.onVariantChange);
    this.observer=new MutationObserver(this.sync);this.observer.observe(this,{subtree:true,attributes:true,attributeFilter:['data-selected']});this.sync();
  }
  disconnectedCallback(){this.observer?.disconnect();this.removeEventListener('change',this.onVariantChange)}
});
  } catch(e) { console.error(e); }
})();

})();
